import { isTagColorId } from '../design/tagPalette';
import type { TagColorId } from '../design/tagPalette';
import { LEGACY_TAG_COLORS } from './legacyTagColors';

/**
 * The one place a stored colour becomes one of the palette's colours.
 *
 * A tag row carries `col` as an id. One of the thirteen is itself; an id the
 * old palette stored reads as the colour it moves to ([LEGACY_TAG_COLORS]),
 * so a vault the app has not rewritten yet still draws in the new palette.
 * Anything else, a raw hex included, is no colour: nothing paints a raw
 * screen colour.
 *
 * It lives here rather than beside the registries because a folder resolves
 * its own colour at build time and `plan/registries.ts` already reads
 * `entity/folders.ts` — putting it there and importing it back is a cycle.
 */
export function tagColorOf(stored: string | null | undefined): TagColorId | null {
  const id = stored?.trim();
  if (!id) return null;
  if (isTagColorId(id)) return id;
  return Object.hasOwn(LEGACY_TAG_COLORS, id) ? (LEGACY_TAG_COLORS[id] ?? null) : null;
}
